var map = {
	"./video1.png": "9437",
	"./video2.png": "0918",
	"./video3.png": "1a84",
	"./video4.png": "a3a3",
	"./video5.png": "f026",
	"./video6.png": "c23a",
	"./video7.png": "f024",
	"./video8.png": "04f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d819";